export default __webpack_public_path__ + "static/media/email.b2a32c4a.svg";